/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Meta_Shown_Decks_AllInputs */



/**
* | totalPlural | output |
* | --- | --- |
* | "one" | "{totalFormatted} archived deck" |
* | * | "{totalFormatted} archived decks" |
*
* @param {Meta_Shown_Decks_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_shown_decks_all = /** @type {((inputs: Meta_Shown_Decks_AllInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Shown_Decks_AllInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const totalPlural = registry.plural("de", i?.total, {}, true);
		const totalFormatted = registry.number("de", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} Deck im Archiv`);
		return /** @type {LocalizedString} */ (`${totalFormatted} Decks im Archiv`)
	}
	if (locale === "fr") {
		const totalPlural = registry.plural("fr", i?.total, {}, true);
		const totalFormatted = registry.number("fr", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} deck archivé`);
		return /** @type {LocalizedString} */ (`${totalFormatted} decks archivés`)
	}
	if (locale === "zh-Hans") {
		const totalPlural = registry.plural("zh-Hans", i?.total, {}, true);
		const totalFormatted = registry.number("zh-Hans", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 副已归档卡组`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 副已归档卡组`)
	}
	if (locale === "zh-Hant") {
		const totalPlural = registry.plural("zh-Hant", i?.total, {}, true);
		const totalFormatted = registry.number("zh-Hant", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 副已封存牌組`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 副已封存牌組`)
	}
	if (locale === "ko") {
		const totalPlural = registry.plural("ko", i?.total, {}, true);
		const totalFormatted = registry.number("ko", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`아카이브된 덱 ${totalFormatted}개`);
		return /** @type {LocalizedString} */ (`아카이브된 덱 ${totalFormatted}개`)
	}
	{
		const totalPlural = registry.plural("en", i?.total, {}, true);
		const totalFormatted = registry.number("en", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} archived deck`);
		return /** @type {LocalizedString} */ (`${totalFormatted} archived decks`)
	}
});